import {
  Box,
  Button,
  Grid,
  IconButton,
  Typography,
  styled,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";

import Card from "components/Card";
import CardInvitation from "./CardInvitation";
import CodeText from "./CodeText";
import { Copy } from "assets/Icon";
import { GetReferralDefault } from "store/api/referral";
import { SummarizeText } from "components/Util/SummarizeText";
import http from "config/http";
import useNotify from "hooks/useNotify";
import { actionButtonBg } from "utils/helpers/actionButtonBg";

function InvitationCode() {
  const theme = useTheme();
  const [referralDefault, setReferralDefault] = useState();
  const notify = useNotify();

  const getReferralDefault = async () => {
    try {
      const { data } = await http.get(GetReferralDefault);
      setReferralDefault(data?.data);
    } catch (error) {
      setReferralDefault({});
      notify(error?.response?.data?.message, "error");
    }
  };

  useEffect(() => {
    getReferralDefault();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const copyToClipAdd = (value) => {
    notify("لینک دعوت با موفقیت کپی شد", "success");
    navigator.clipboard.writeText(value);
  };

  const copyToClipAddCode = (value) => {
    notify("کد دعوت با موفقیت کپی شد", "success");
    navigator.clipboard.writeText(value);
  };

  return (
    <Card minHeight={"455px"} marginBottom={3}>
      <Box minHeight="320px" maxHeight="320px">
        <Typography variant="h4" paddingBottom={1}>
          کد دعوت پیش فرض
        </Typography>

        <Typography
          variant="h6"
          color="text.secondary"
          paddingBottom={3}
          fontWeight={400}
        >
          دوستانتان را با لینک مخصوص خودتان به برنامه دعوت کنید
        </Typography>

        <Grid container spacing={2} mb={2}>
          <Grid item xs={6}>
            <CardInvitation
              title={"کارمزد دریافتی شما"}
              number={`${referralDefault?.referralPercentParent || 0}%`}
            />
          </Grid>

          <Grid item xs={6}>
            <CardInvitation
              title={"کارمزد دریافتی دوستان"}
              number={`${referralDefault?.referralPercentChild || 0}%`}
            />
          </Grid>
        </Grid>

        <Grid item display="flex" xs={12} alignItems="baseline">
          <CodeText
            title={"کد دعوت"}
            text={`${referralDefault?.referralCode || "-"}`}
          />
          <Typography mr={1}>
            <IconButton
              aria-label="copy"
              onClick={() => {
                copyToClipAddCode(referralDefault?.referralCode);
              }}
            >
              <Copy color={theme.palette.secondary.main} />
            </IconButton>
          </Typography>
        </Grid>

        <CodeText
          title={" لینک دعوت"}
          text={SummarizeText(`${referralDefault?.link || "-"}`, 20)}
        />
      </Box>

      <BoxButton>
        <Button
          color={actionButtonBg(theme)}
          fullWidth
          onClick={() => {
            copyToClipAdd(referralDefault?.link);
          }}
        >
          <ion-icon name="copy-outline" />
          کپی کردن لینک
        </Button>
      </BoxButton>
    </Card>
  );
}
const BoxButton = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3, 6),
  ".MuiButtonBase-root": {
    "ion-icon": {
      paddingLeft: theme.spacing(1),
    },
  },
}));
export default InvitationCode;
